const WA_LINK = "https://wa.me/554891802091?text=Ol%C3%A1%2C%20gostaria%20de%20informa%C3%A7%C3%B5es%20das%20m%C3%A1quinas.........";

export default function WhatsAppButton() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (typeof window !== 'undefined' && window.gtag_report_conversion) {
      window.gtag_report_conversion(WA_LINK, true);
    } else {
      window.open(WA_LINK, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white rounded-full hover:bg-[#1ebe5d] transition-all duration-300 hover:scale-105 cursor-pointer group"
      aria-label="Fale conosco pelo WhatsApp"
    >
      <span className="hidden group-hover:flex items-center whitespace-nowrap pl-5 pr-1 py-3 text-sm font-bold tracking-wide">
        Fale pelo WhatsApp
      </span>
      <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] group-hover:bg-[#1ebe5d] transition-colors duration-300 flex-shrink-0">
        <i className="ri-whatsapp-line text-2xl" />
      </span>
    </a>
  );
}